export const VeryDisappointedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1_422)">
        <path
          d="M19.9999 39.1666C30.5854 39.1666 39.1666 30.5854 39.1666 19.9999C39.1666 9.41446 30.5854 0.833252 19.9999 0.833252C9.41446 0.833252 0.833252 9.41446 0.833252 19.9999C0.833252 30.5854 9.41446 39.1666 19.9999 39.1666Z"
          fill="#10B981"
        />
        <path
          d="M19.9999 7.49992C24.1407 7.50023 28.1848 8.75081 31.6029 11.0879C35.021 13.4251 37.6538 16.7398 39.1566 20.5983C39.1566 20.3983 39.1666 20.1999 39.1666 19.9999C39.1666 14.9166 37.1472 10.0415 33.5528 6.44704C29.9584 2.85259 25.0832 0.833252 19.9999 0.833252C14.9166 0.833252 10.0415 2.85259 6.44704 6.44704C2.85259 10.0415 0.833252 14.9166 0.833252 19.9999C0.833252 20.1999 0.833252 20.3983 0.843252 20.5983C2.34601 16.7398 4.97879 13.4251 8.39691 11.0879C11.815 8.75081 15.8592 7.50023 19.9999 7.49992Z"
          fill="#ECFDF5"
        />
        <path
          d="M19.9999 39.1666C30.5854 39.1666 39.1666 30.5854 39.1666 19.9999C39.1666 9.41446 30.5854 0.833252 19.9999 0.833252C9.41446 0.833252 0.833252 9.41446 0.833252 19.9999C0.833252 30.5854 9.41446 39.1666 19.9999 39.1666Z"
          stroke="#00303E"
          strokeWidth="1.70833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8334 16.25C10.9158 16.25 10.9964 16.2744 11.0649 16.3202C11.1334 16.366 11.1868 16.4311 11.2184 16.5072C11.2499 16.5834 11.2582 16.6671 11.2421 16.748C11.226 16.8288 11.1863 16.903 11.128 16.9613C11.0698 17.0196 10.9955 17.0593 10.9147 17.0753C10.8339 17.0914 10.7501 17.0832 10.674 17.0516C10.5978 17.0201 10.5328 16.9667 10.487 16.8982C10.4412 16.8296 10.4167 16.7491 10.4167 16.6667C10.4167 16.5562 10.4606 16.4502 10.5388 16.372C10.6169 16.2939 10.7229 16.25 10.8334 16.25Z"
          stroke="#00303E"
          strokeWidth="1.70833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.1667 16.25C29.0843 16.25 29.0037 16.2744 28.9352 16.3202C28.8667 16.366 28.8133 16.4311 28.7817 16.5072C28.7502 16.5834 28.7419 16.6671 28.758 16.748C28.7741 16.8288 28.8138 16.903 28.872 16.9613C28.9303 17.0196 29.0046 17.0593 29.0854 17.0753C29.1662 17.0914 29.25 17.0832 29.3261 17.0516C29.4023 17.0201 29.4673 16.9667 29.5131 16.8982C29.5589 16.8296 29.5833 16.7491 29.5833 16.6667C29.5833 16.5562 29.5394 16.4502 29.4613 16.372C29.3832 16.2939 29.2772 16.25 29.1667 16.25Z"
          stroke="#00303E"
          strokeWidth="1.70833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 31.6667C12.5 29.6776 13.2902 27.77 14.6967 26.3634C16.1032 24.9569 18.0109 24.1667 20 24.1667C21.9891 24.1667 23.8968 24.9569 25.3033 26.3634C26.7098 27.77 27.5 29.6776 27.5 31.6667"
          stroke="#00303E"
          strokeWidth="1.70833"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_422">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
